import Button from '@mui/material/Button';
import { useState, useEffect } from 'react';
import Tasks from '../components/Tasks';
import { useTheme } from '@mui/material/styles';
import Form from '../components/RNAI/Form';
import WatchGuideLink from '../components/WatchGuideLink/WatchGuideLink';

const TryRNAIPage = () => {
  const theme = useTheme();
  const [activeButton, setActiveButton] = useState('Try RNAI');

  useEffect(() => {
    document.title = 'RNAI - The Simple Platform';
  }, []);

  const navigateOnSubmit = () => {
    setActiveButton('Private Verticals');
  };

  const activeButtonStyle = {
    textTransform: 'none',
    margin: '10px 10px 10px 0px',
    color: theme.palette.primary.main,
    fontWeight: 'bold',
    borderBottom: '2px solid',
    borderColor: 'primary.main',
    borderRadius: 0,
    paddingBottom: '4px',
  };
  const buttonStyle = {
    textTransform: 'none',
    margin: '10px 10px 10px 0px',
    color: 'black',
  };

  return (
    <>
      <div
        style={{
          textAlign: 'left',
          width: '85%',
          margin: '0 auto',
          marginBottom: '12px',
          marginTop: '12px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <div style={{ display: 'flex', flexWrap: 'nowrap', flexShrink: 0, whiteSpace: 'nowrap' }}>
          <Button
            variant="text"
            disableRipple={true}
            sx={activeButton === 'Try RNAI' ? activeButtonStyle : buttonStyle}
            onClick={() => setActiveButton('Try RNAI')}
          >
            Search RNAI
          </Button>
          <Button
            variant="text"
            disableRipple={true}
            sx={activeButton === 'Private Verticals' ? activeButtonStyle : buttonStyle}
            onClick={() => setActiveButton('Private Verticals')}
          >
            Private Verticals
          </Button>
          <Button
            variant="text"
            disableRipple={true}
            sx={activeButton === 'My Verticals' ? activeButtonStyle : buttonStyle}
            onClick={() => setActiveButton('My Verticals')}
          >
            My Verticals
          </Button>
          <Button
            variant="text"
            disableRipple={true}
            sx={activeButton === 'Joined Verticals' ? activeButtonStyle : buttonStyle}
            onClick={() => setActiveButton('Joined Verticals')}
          >
            Joined Verticals
          </Button>
        </div>
      </div>

      {activeButton === 'Try RNAI' && (
        <div style={{ width: '85%', margin: '0 auto 8px', textAlign: 'left' }}>
          <WatchGuideLink videoId="creating-a-vertical" label="Watch Guide: Creating a Vertical" />
        </div>
      )}

      <div
        style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '80vw' }}
      >
        {activeButton === 'Try RNAI' ? (
          <Form navigateOnSubmit={navigateOnSubmit} />
        ) : (
          <Tasks activeTab={activeButton} />
        )}
      </div>
    </>
  );
};
export default TryRNAIPage;
